import Profile from '../models/profile.model';

let storeContent = utils.generateStore({
	Profile,
	invoices: [],
	schemes: [],
	group_schemes: [],
	scheme_products: [],
	scheme_details: null,
	selected_scheme: null,
	securityQuestions: [],
	showUpdateModal: false,
	showGroupScheme: false,
	showSchemeDetails: false,
	showInviteForm: false,
	invite_summary: {
		invites: {
			no_invited: 0,
		},
		referrals: {
			in_progress: 0,
			success: 0,
		},
	},
	type: 1,
	total_schemes: 0,
	email: '',
	names: '',
	contact: '',
});

export default {
	state() {
		return { ...storeContent.state };
	},
	getters: {
		...storeContent.getters,
	},
	mutations: {
		...storeContent.mutations,
	},
	actions: {
		async updateProfile(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					// let res = await api.fetchEndpoint({
					//    resource: "forgot_password",
					//    action: "request",
					//    data: {
					//       firstname: data.first_name,
					//       lastname: data.last_name,
					//       username: data.email,
					//    }
					// }, '/client')

					$notify(
						'success',
						'Update Profile',
						`Profile Successfully Updated`,
						10,
					);
					ctx.commit('page', 3);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async sendInvite(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpoint(
						{
							resource: 'marketing',
							action: 'invite',
							data: {
								lead_email: data.email,
								invite_remarks: data.remarks,
							},
						},
						'/client',
					);

					ctx.commit('showInviteForm', false);
					$notify(
						'success',
						'Invite Sent',
						`Invite successfully sent to ${data.email}`,
						10,
					);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async updatePassword(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (data.password !== data.confirmPassword) {
					$notify(
						'warning',
						'Validation Error',
						`Password does not match Confirm Password.`,
						10,
					);
					ctx.commit('loading', false);
					return false;
				}

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpoint(
						{
							resource: 'password',
							action: 'update',
							data: {
								password: data.confirmPassword,
							},
						},
						'/client',
					);

					ctx.commit('showUpdateModal', false);
					$notify(
						'success',
						'Password Changed',
						`Password Successfully Updated.`,
						10,
					);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async updateSecurityQuestion(ctx, payload) {
			try {
				ctx.commit('loading', true);
				let data = payload.ref.formData_;

				if (await payload.ref.isValid()) {
					let res = await api.fetchEndpoint(
						{
							resource: 'profile',
							action: 'security_questions_update',
							data: {
								security_questions: data.questions,
							},
						},
						'/client',
					);

					await ctx.dispatch('fetchSecurityQuestions');
					ctx.commit('showUpdateModal', false);
					$notify(
						'success',
						'Security Questions Updated',
						`Security questions created and updated.`,
						10,
					);
				}

				ctx.commit('loading', false);
			} catch (err) {
				ctx.commit('loading', false);
				throw err;
			}
		},
		async fetchSecurityQuestions(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'profile',
						action: 'list_security_questions',
						data: {},
					},
					'/client',
				);

				ctx.commit('securityQuestions', res.result);
			} catch (err) {
				throw err;
			}
		},
		async fetchSchemes(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'scheme',
						action: 'list',
						data: {},
					},
					'/client',
				);

				ctx.commit('total_schemes', res.result.client_schemes.length);
				ctx.commit('schemes', res.result.client_schemes);
			} catch (err) {
				throw err;
			}
		},
		async fetchClientDetails(ctx) {
			try {
				let user = await $session.get('user');
				console.log('user', user);
				if (user && user.client_details) {
					ctx.commit('email', user.email);
					ctx.commit('names', user.client_details.names);
					ctx.commit('contact', user.contact);
				}
			} catch (err) {
				throw err;
			}
		},
		closeModal(ctx, type) {
			ctx.commit('showUpdateModal', false);
		},
		openModal(ctx, type) {
			ctx.commit('type', type);
			console.log(type);

			if (type === 1) {
				let profile = ctx.getters.Profile;
				profile.forms.update_profile.data = {
					names: ctx.getters.names,
					email: ctx.getters.email,
					contact: ctx.getters.contact,
					profilePhoto: '',
				};

				ctx.commit('Profile', profile);
				ctx.commit('showUpdateModal', true);
			} else if (type === 2) {
				ctx.commit('type', 2);
				ctx.commit('showUpdateModal', true);
			} else {
				ctx.commit('showUpdateModal', true);
			}
		},
		async fetchInviteSummary(ctx) {
			try {
				let res = await api.fetchEndpointSecure(
					{
						resource: 'marketing',
						action: 'summary',
						data: {},
					},
					'/client',
				);

				ctx.commit('invite_summary', res.result.summary);
			} catch (err) {
				throw err;
			}
		},
		async viewGroupSchemes(ctx, scheme) {
			try {
				Event.$emit('loader:show', true);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'scheme',
						action: 'groups',
						data: {
							system_scheme_ref: scheme.system_scheme_ref,
						},
					},
					'/client',
				);

				ctx.commit('selected_scheme', scheme);
				ctx.commit('group_schemes', res.result.client_scheme_group);
				ctx.commit('showGroupScheme', true);
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async acceptGroupScheme(ctx, system_ref) {
			try {
				Event.$emit('loader:show', true);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'scheme',
						action: 'accept_invite',
						data: {
							system_scheme_member_ref: system_ref,
						},
					},
					'/client',
				);

				await ctx.dispatch(
					'viewGroupSchemes',
					ctx.getters.selected_scheme,
				);
				ctx.commit('showSchemeDetails', false);
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async rejectGroupScheme(ctx, system_ref) {
			try {
				Event.$emit('loader:show', true);

				let res = await api.fetchEndpointSecure(
					{
						resource: 'scheme',
						action: 'reject_invite',
						data: {
							system_scheme_member_ref: system_ref,
						},
					},
					'/client',
				);

				ctx.commit('showSchemeDetails', false);
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async viewSchemeDetails(ctx, scheme) {
			try {
				Event.$emit('loader:show', true);
				let res = await api.fetchEndpointSecure(
					{
						resource: 'scheme',
						action: 'group_product',
						data: {
							system_scheme_group_ref:
								scheme.group_details.system_scheme_group_ref,
						},
					},
					'/client',
				);

				ctx.commit('scheme_details', scheme);
				ctx.commit('scheme_products', res.result.group_products);
				ctx.commit('showSchemeDetails', true);
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
		async fetchData(ctx) {
			try {
				await ctx.dispatch('fetchSchemes');
				await ctx.dispatch('fetchSecurityQuestions');
				await ctx.dispatch('fetchClientDetails');
				await ctx.dispatch('fetchInviteSummary');
				Event.$emit('loader:show', false);
			} catch (err) {
				Event.$emit('loader:show', false);
				throw err;
			}
		},
	},
};
